if (!customElements.get("sticky-atc-bar")) {
  customElements.define(
    "sticky-atc-bar",
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add("sticky-atc-bar-enabled");

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(
          ".f-main-product-form"
        );
        this.container = this.closest(".sticky-atc-bar");
        this.mainProduct = document.querySelector(
          "product-info[id^='MainProduct']"
        );

        this.variantData = this.getVariantData();
        this.select = this.querySelector("select");

        this.init();
        this.select.addEventListener("change", () => {
          const mainVariantPicker =
            this.mainProduct.querySelector("variant-picker");
          const selectedVariantId = this.querySelector(
            this.selectors.variantIdSelect
          ).value;
          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(selectedVariantId)
          );

          if (mainVariantPicker) {
            Array.from(
              mainVariantPicker.querySelectorAll(
                "select, .variant-picker__option-values"
              ),
              (element, index) => {
                const variantOptionVal = this.currentVariant.options[index];
                switch (element.tagName) {
                  case "SELECT":
                    element.value = variantOptionVal;
                    break;
                  case "DIV":
                    Array.from(element.querySelectorAll("input")).forEach(
                      (radio) => {
                        if (radio.value === variantOptionVal) {
                          radio.checked = true;
                        }
                      }
                    );
                    break;
                }
              }
            );
            mainVariantPicker.dispatchEvent(new Event("change"));
          }

          this.updatePrice();
          this.updateButton(true, "", false);
          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(
              !this.currentVariant.available,
              window.FoxThemeStrings.soldOut
            );
          }
        });
      }

      getVariantData() {
        if (!this.variantData) {
          const local = this.container.querySelector(
            'script[type="application/json"]'
          );
          if (local) {
            this.variantData = JSON.parse(local.textContent);
          } else {
            const productData = document.getElementById("ProductData");
            this.variantData = productData
              ? JSON.parse(productData.textContent).variants
              : [];
          }
        }
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add("sticky-atc-bar--show");
          return;
        }
        this.productId = this.dataset.productId;
        const isMobile = window.matchMedia("(max-width: 639px)");

        try {
          // Chrome & Firefox
          isMobile.addEventListener("change", this.checkDevice.bind(this));
        } catch (err) {
          try {
            // Safari
            isMobile.addListener(this.checkDevice.bind(this));
          } catch (e2) {
            console.error(e2);
          }
        }

        // Initial check
        this.checkDevice(isMobile);

        const headerHeight = window.FoxThemeSettings.headerHeight || 80;
        const rootMargin = `-${headerHeight}px 0px 0px 0px`;
        // Show only once the main buttons have scrolled up past the header, not while they
        // are still below the fold (design review 2, 2026-09-25). A scroll check rather than an
        // IntersectionObserver so jumps (anchor links, fast scrolls) past the buttons still count.
        let queued = false;
        const update = () => {
          queued = false;
          const target = this.observeTarget || this.productFormActions;
          if (!target) return;
          const passed = target.getBoundingClientRect().bottom < headerHeight;
          this.container.classList.toggle("sticky-atc-bar--show", passed);
          document.documentElement.classList.toggle("sh-sticky-open", passed);
        };
        window.addEventListener("scroll", () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(update);
        }, { passive: true });
        this.observer = { observe: () => update(), disconnect: () => {} };
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        // Read layout inside rAF so the measurement batches with the
        // browser's own layout pass instead of forcing a synchronous
        // reflow mid-task (flagged by Lighthouse on this file).
        setTimeout(() => {
          requestAnimationFrame(() => {
            const sectionHeight = this.clientHeight + "px";
            document.documentElement.style.setProperty(
              "--f-sticky-atc-bar-height",
              sectionHeight
            );
          });
        }, 100);
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          "product-form-sticky-atc-bar"
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector(
          '[name="add"] > span:not(.f-icon)'
        );

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.FoxThemeStrings.addToCart;
        }
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(
          this.selectors.variantIdSelect
        ).value;
        this.currentVariant = this.variantData.find(
          (variant) => variant.id === Number(selectedVariantId)
        );
        fetch(
          `${this.getAttribute("data-url")}?variant=${
            this.currentVariant.id
          }&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const quantity = document.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );
            const newQuantity = parsedHTML.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      updatePrice() {
        const classes = {
          onSale: "f-price--on-sale",
          soldOut: "f-price--sold-out",
        };
        const selectors = {
          priceWrapper: ".f-price",
          salePrice: ".f-price-item--sale",
          compareAtPrice: [".f-price-item--regular"],
          unitPrice: ".f-price__unit",
          saleBadge: ".f-price__badge-sale",
          saleAmount: "[data-sale-value]",
        };
        const money_format = window.FoxThemeSettings.money_format;
        const { priceWrapper, salePrice, unitPrice, compareAtPrice } =
          queryDomNodes(selectors, this);

        let { compare_at_price, price } = this.currentVariant;
        const { unit_price_measurement } = this.currentVariant;

        // Promo pricing. Shopify automatic discounts are cart-only, so the
        // variant object carries the UNDISCOUNTED price. snippets/price.liquid
        // synthesises the promo display server-side and publishes the percent
        // as data-promo-percent; reproduce the same maths here or a variant
        // change reverts the bar to full price.
        // Must match price.liquid exactly: Liquid's `divided_by: 100` on
        // integers truncates, hence Math.floor.
        //
        // Prefer the PRODUCT-level percent: data-promo-percent reflects
        // whichever variant rendered first, so on an excluded variant it is
        // absent — and we could then never re-apply the promo when the
        // shopper switches back to an included variant.
        const ds = (priceWrapper && priceWrapper.dataset) || {};
        const promoPercent = parseInt(
          ds.promoPercentProduct || ds.promoPercent || "0",
          10
        );
        // Variants the discount excludes (e.g. TrailStar Maximus leather).
        const promoExcluded = (ds.promoExcluded || "")
          .split(",")
          .filter(Boolean);
        const variantExcluded = promoExcluded.includes(
          String(this.currentVariant.id)
        );
        if (promoPercent > 0 && !variantExcluded) {
          if (!compare_at_price || compare_at_price < price) {
            compare_at_price = price;
          }
          price = Math.floor((price * (100 - promoPercent)) / 100);
        }

        const onSale = compare_at_price && compare_at_price > price;
        const soldOut = !this.currentVariant.available;

        if (onSale) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        if (soldOut) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (priceWrapper) priceWrapper.classList.remove("visibility-hidden");
        if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);

        if (
          compareAtPrice &&
          compareAtPrice.length &&
          compare_at_price > price
        ) {
          compareAtPrice.forEach(
            (item) =>
              (item.innerHTML = formatMoney(compare_at_price, money_format))
          );
        } else {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = formatMoney(price, money_format))
          );
        }

        if (unit_price_measurement && unitPrice) {
          unitPrice.classList.remove("f-hidden");
          const unitPriceContent = `<span>${formatMoney(
            this.currentVariant.unit_price,
            money_format
          )}</span>/<span data-unit-price-base-unit>${getBaseUnit(
            this.currentVariant
          )}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPrice.classList.add("f-hidden");
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
          const isMainProduct =
            evt.data.sectionId === this.mainProduct.dataset.section;
          if (!isMainProduct) return;
          this.currentVariant = evt.data.variant;
          if (this.currentVariant) {
            this.container.classList.remove("f-hidden");
            variantInput.value = evt.data.variant.id;
            // Rebuild the worded configuration to match the hidden select.
            // Options are matched by name so a product that orders or omits
            // them differently still renders sensibly.
            const info = this.querySelector("[data-option-names]");
            const titleEl = this.querySelector("[data-sticky-title]");
            const variantLabel = this.querySelector("[data-sticky-variant-label]");
            if (info) {
              const names = (info.dataset.optionNames || "")
                .split("|")
                .map((n) => n.trim().toLowerCase());
              const values = evt.data.variant.options || [];
              let optSize = "", optStyle = "", optColor = "";
              names.forEach((n, i) => {
                if (n === "size") optSize = values[i] || "";
                else if (n === "style") optStyle = values[i] || "";
                else if (n === "color" || n === "colour") optColor = (values[i] || "").replace(" (See Note)", "");
              });
              if (titleEl) {
                titleEl.textContent = optStyle
                  ? `${info.dataset.productTitle} ${optStyle}`
                  : info.dataset.productTitle;
              }
              if (variantLabel) {
                const detail = [optColor, optSize ? `Size ${optSize}` : ""]
                  .filter(Boolean)
                  .join(" \u00b7 ");
                variantLabel.textContent = detail || evt.data.variant.title || "";
              }
            }
            this.updatePrice();
            this.updateButton(true, "", false);
            if (!evt.data.variant) {
              this.updateButton(true, "", false);
            } else {
              this.updateButton(
                !evt.data.variant.available,
                window.FoxThemeStrings.soldOut
              );
            }
          } else {
            this.container.classList.add("f-hidden");
          }

          this.updateQuantityInput();
        });
      }
    }
  );
}
